import React from "react"
import { get } from "lodash"

import { StatisticList } from "components/molecules/list/statistics"
import { Panel } from "./index"
import { APIResponse } from "redux/apis/types"
import * as Formatter from "utils/Formatter"
import { statisticsApiCall } from "components/actions/divisionStatistics"

type Props = {
  delete?: Function
  statisticsData?: APIResponse.Res
  updateFunc?: Function
}

export const MarketStatistics = (props: Props) => {
  return (
    <Panel
      title={
        <>
          <span className="panel-header-title-items">市場統計</span>
          {/*<span className="panel-header-title-items">*/}
          {/*  <div className="time-col liquid-item">*/}
          {/*    {Formatter.date(*/}
          {/*      get(props.statisticsData[0], "CreatedTime"),*/}
          {/*      "MM/DD HH:mm"*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</span>*/}
        </>
      }
      // refresh={() =>
      //   statisticsApiCall({
      //     updateStatistics: props.updateFunc,
      //     division: "0111,0114,0124",
      //   })
      // }
      delete={props.delete}
      className="panel-market-statistics"
    >
      {typeof props.statisticsData === "object" ? (
        <StatisticList
          statisticsData={[
            props.statisticsData[0],
            props.statisticsData[1],
            props.statisticsData[2],
          ]}
        />
      ) : null}
    </Panel>
  )
}
